module.exports = __webpack_public_path__ + "static/media/volar-gold.615f5323.png";